import { Action } from '@ngrx/store';
import { RoomConfiguration } from './room-configuration.reducer';

export enum RoomConfigurationActionTypes {
  LOAD_ROOM_CONFIGURATION = '[Room Configuration] Load room configuration',
  SET_ROOM_CONFIGURATION = '[Room Configuration] Set room configuration',
  ROOM_CONFIGURATION_LOADED = '[Room Configuration API] Room configuration loaded',
}

export class LoadRoomConfiguration implements Action {
  readonly type = RoomConfigurationActionTypes.LOAD_ROOM_CONFIGURATION;

  constructor(public payload: { hotelCode: string; unitCode: string }) {}
}

export class RoomConfigurationLoaded implements Action {
  readonly type = RoomConfigurationActionTypes.ROOM_CONFIGURATION_LOADED;

  constructor(public payload: RoomConfiguration) {}
}

export class SetRoomConfiguration implements Action {
  readonly type = RoomConfigurationActionTypes.SET_ROOM_CONFIGURATION;

  constructor(public payload: RoomConfiguration) {}
}

export type RoomConfigurationActionsUnion = LoadRoomConfiguration | RoomConfigurationLoaded | SetRoomConfiguration;
